import Vue from 'vue';
import App from './App.vue';
import router from './router';
import * as Msal from 'msal';
import { AppConfig } from './app-config';
import { AppUtils } from './utils/appUtils';

Vue.config.productionTip = false;

// グローバル変数は vue-global-property.d.ts で定義、以下で初期化する。
// Vueの初期化前に挿入することで使用タイミングを調整する。
Vue.$userAgentApplication = new Msal.UserAgentApplication({
	auth: {
		clientId: AppConfig.AUTH_CLIENT_ID,
		authority: AppConfig.AUTHORITY,
	},
	cache: {
		// IEやEdgeで認証後のリダイレクト時に状態が取れない問題を解消するための設定
		storeAuthStateInCookie: true,
	}
});
// TODO ログインエラー時の対応
Vue.$userAgentApplication.handleRedirectCallback((response: Msal.AuthResponse) => {
	// console.log('UserAgentApplietion.tokenReceivedCallback()');
}, () => {
	// console.log('UserAgentApplietion.errorReceivedCallback()');
});
AppUtils.loadAccessTokenInfo();

new Vue({
	router,
	render: (h) => h(App),
}).$mount('#app');
